import React from "react";
import CommonStyles from "../../../../../Diathrive/src/utils/CommonStyles";
import styles from "./styles";
import { PLAYSTORE_LINK, APPSTORE_LINK } from "../../../utils/Constants";
import { tID } from "../../../../../Diathrive/src/utils/TestIdHelper";
import { Images } from "../../../utils/Images";

const MobileAppStoreLinks = ({
  containerStyle = {},
  testIdScreenName = "",
}) => {
  return (
    <div style={{ ...CommonStyles.flex_display, ...containerStyle }}>
      <a
        data-testid={tID(
          `${testIdScreenName ? testIdScreenName + "-" : ""}Link-AppStore`
        )}
        target="_blank"
        href={APPSTORE_LINK}
      >
        <img src={Images.appStore} style={styles.storeImage} />
      </a>
      <a
        data-testid={tID(
          `${testIdScreenName ? testIdScreenName + "-" : ""}Link-PlayStore`
        )}
        target="_blank"
        href={PLAYSTORE_LINK}
      >
        <img
          src={Images.playStore}
          style={{ ...styles.storeImage, ...CommonStyles.ml_12 }}
        />
      </a>
    </div>
  );
};

export default MobileAppStoreLinks;
